import React, { Fragment, useState } from "react";
import styled from "styled-components";
import {
  AppleLoginSrc,
  CheckCircleGraySrc,
  CheckCirclePurpleSrc,
  KakaoLoginSrc,
  NaverLoginSrc,
} from "../../../resources/Assets";

export const UserInfoList = props => {
  const { idx, data } = props;
  return (
    <ListDiv default={idx == 0 ? true : false}>
      {/* 사용자 정보 */}
      <InfoDiv>
        <InfoText style={{ display: "flex", gap: "16px" }}>
          {checkUserId(data)}
        </InfoText>
        <InfoText style={{ display: "flex", gap: "16px" }}>
          <InfoTextTitle>휴대폰번호</InfoTextTitle>
          <InfoTextItem>{data.userPhone} </InfoTextItem>
        </InfoText>
        <InfoText style={{ display: "flex", gap: "16px" }}>
          <InfoTextTitle>최근사용일</InfoTextTitle>
          <InfoTextItem>{data.recentDate} </InfoTextItem>
        </InfoText>
      </InfoDiv>
    </ListDiv>
  );
};

const checkUserId = data => {
  if (data.signUpChannel === "000" || data.signUpChannel === "500") {
    return (
      <Fragment>
        <InfoTextTitle>아이디</InfoTextTitle>
        <InfoTextItem>{data.userId}</InfoTextItem>
      </Fragment>
    );
  } else if (data.signUpChannel === "100") {
    return <img src={NaverLoginSrc} />;
  } else if (data.signUpChannel === "400") {
    return <img src={KakaoLoginSrc} />;
  } else {
    return <img src={AppleLoginSrc} />;
  }
};

export const ListDiv = styled.div`
  display: flex;
  /* padding: 10px 24px; */
  padding: 12px;
  justify-content: space-between;
  align-items: center;

  border-radius: 4px;
  border: 1px solid #f5f5f5;
  background: ${props => (props.default ? "#F0F0F0" : "#FAFAFA")};

  margin-bottom: 20px;
`;

export const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`;

export const InfoText = styled.div`
  color: #000;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const InfoTextTitle = styled.div`
  width: 62px;
  font-weight: 500;
  color: #333;
`;

const InfoTextItem = styled.div`
  font-weight: normal;
  color: #666;
`;

export const CheckContainer = styled.label`
  width: 28px;
  height: 28px;
  background: url(${props =>
    props.checked ? CheckCirclePurpleSrc : CheckCircleGraySrc});
  background-size: contain;
  flex-shrink: 0;
`;
